import { useEffect } from "react";
import { createT } from "#/lib/i18n.js";

type Props = {
  locale: string;
  siteId: string;
  apkUrl: string;
  pwaName: string;
  pwaShortName: string;
};

export { Page };

function Page({ locale, siteId, apkUrl, pwaName, pwaShortName }: Props) {
  const t = createT(locale, "download");

  // Auto-trigger the APK download once on mount. The fallback link below
  // is the canonical path if the auto-trigger is blocked (rare; iOS Safari
  // doesn't render this page, but Android Chrome may also throttle).
  useEffect(() => {
    const a = document.createElement("a");
    a.href = apkUrl;
    a.download = `${siteId}.apk`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }, [apkUrl, siteId]);

  return (
    <>
      <main
        id="main-content"
        className="mx-auto max-w-xl px-4 py-12"
        data-site-id={siteId}
      >
        <header className="mb-6 flex flex-col gap-2">
          <h1 className="text-3xl font-semibold text-[color:var(--color-fg-default)]">
            {t("android.title", { name: pwaName })}
          </h1>
          <p className="text-base text-[color:var(--color-fg-muted)]">
            {t("android.fallback")}{" "}
            <a className="underline font-medium" href={apkUrl} download>
              {t("android.fallbackLink", { shortName: pwaShortName })}
            </a>
            .
          </p>
        </header>
        <ol className="list-decimal ms-5 space-y-2 text-sm text-[color:var(--color-fg-muted)]">
          <li>{t("android.steps.openFile")}</li>
          <li>{t("android.steps.allowSource")}</li>
          <li>{t("android.steps.openApp", { shortName: pwaShortName })}</li>
        </ol>
      </main>
    </>
  );
}
